<template>
  <div>
    {{ rule.config.term }}-Term KAMA, Current Price {{ rule.config.above_below }} KAMA.
    {{ rule.config.consecutive_days }} consecutive days price has been above or below KAMA. Closing
    Price {{ rule.config.percent }}% Above or Below KAMA
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {}
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
